/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import { App, Feature, Menu, render } from '@mairistem/module';
import { request } from '@mairistem/tools';

import Context from '@/Context';
import Gestionnaire from './components/Gestionnaire';

import 'react-toastify/dist/ReactToastify.css';
import './index.less';

request.interceptors.request.use((config) => {
  if (process.env.NODE_ENV === 'production') {
    if (_.includes(window.location.href, '.jvsonline.fr')) {
      // eslint-disable-next-line no-param-reassign
      config.baseURL = 'https://360.jvsonline.fr';
    } else if (_.includes(window.location.href, '.qa.')) {
      // eslint-disable-next-line no-param-reassign
      config.baseURL = 'https://360.qa.jvs-mairistem.dev';
    } else if (_.includes(window.location.href, '.pp.')) {
      // eslint-disable-next-line no-param-reassign
      config.baseURL = 'https://360.pp.jvs-mairistem.dev';
    } else {
      // eslint-disable-next-line no-param-reassign
      config.baseURL = 'https://360.jvs-mairistem.dev';
    }
  } else {
    config.headers['X-Database'] = process.env.X_DATABASE;
    config.headers['X-Login'] = 1;
  }
  return config;
});

render(
  <App
    group="administres"
    name="Annotations"
    code="360_GAN"
    request={request}
    context={Context}
    embedded
    additionalProductCodesUpdate={['HOL_ETCV']}
  >
    <Menu.Home>
      <Feature>
        {/* Ugly hack to kind of have a redirection */}
        {/* We're instanciating because it simply doesn't work otherwise */}
        <Feature.Content>
          <Gestionnaire />
        </Feature.Content>
      </Feature>
    </Menu.Home>
    <Menu name="Gestionnaire" icon="edit" path="/gestionnaire">
      <Feature>
        <Feature.Content>{Gestionnaire}</Feature.Content>
      </Feature>
    </Menu>
  </App>,
);
